import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestGetEmpDto, ResponseGetEmpDto } from '../dto/sf-career.dto';
import { ResponsePaging } from "../../nest-responses";


@Injectable()
export class SFCareerApi {

  private service: string = '';
  private model: string = 'sfCareer';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public addCareer(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addCareer';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getEmp(payload: RequestGetEmpDto, queryParams?: { page: number, limit: number }): Observable<ResponsePaging<ResponseGetEmpDto>> {
    const method: string = 'POST';
    const func: string = 'getEmp';
    const params: any = payload || {};
    const urlParams: any = queryParams || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetEmpDto>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/sf-career.api.ts